enum ManagerRadioButtonOptions {
  MOST_PROJECTS_FIRST = "highest",
  LEAST_PROJECTS_FIRST = "lowest",
}

export default ManagerRadioButtonOptions;